import { useState, useEffect, useCallback } from 'react'
import TextField from '@mui/material/TextField'
import { Auth } from 'aws-amplify'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import { useLocation } from 'react-router-dom'
import useNavigate from '../../helpers/useNavigation'
import { Alert } from '@mui/material'
import { useStyles } from './style'
import useInput from '../../utils/useInput'
import { useSelector } from 'react-redux'
import clientConfig from '../../reducers/clientConfig'
import { Forbidden } from '../index'

const Confirmation = () => {
  const { state } = useLocation()
  const [loading, setLoading] = useState(false)
  const [localSent, setLocalSent] = useState(state?.sent)
  const [info, setInfo] = useState({ error: false, message: '' })
  const navigate = useNavigate()
  const classes = useStyles()
  const { value: code, bind: bindCode } = useInput('', { code: true })
  const { identityProviders } = useSelector(clientConfig.selectors.selectClientConfig)

  const resendCode = useCallback(async () => {
    try {
      await Auth.resendSignUp(state?.email)
    } catch (error) {
      setInfo({ error: true, message: error.message })
      setTimeout(() => navigate('/signin'), 3000)
    }
  }, [navigate, state?.email])

  useEffect(() => {
    if (!localSent && state?.email) {
      resendCode()
      setLocalSent(true)
    }
  }, [resendCode, localSent, state?.email])

  const handleSubmit = async e => {
    e.preventDefault()
    setLoading(true)

    try {
      await Auth.confirmSignUp(state?.email, code)
      alert('The account was confirmed successfully.')
      if (state?.redirectTo) {
        navigate(state.redirectTo)
      } else {
        navigate('/dashboard')
      }
    } catch (error) {
      setInfo({ error: true, message: error.message })
    }
    setLoading(false)
  }
  const isEmptyEmail = !state?.email || state?.email.length === 0
  const isCognitoProvider = identityProviders?.find(provider => provider.toLowerCase() === 'cognito') && identityProviders.length === 1
  const invalidPage = isEmptyEmail || !isCognitoProvider

  return (
    invalidPage ? <Forbidden /> : (
      <div className={classes.container}>
        <img className={classes.logo} src='/img/logo.png' alt='Resilience Engine Logo' />
        <form
          className={classes.form}
          onSubmit={handleSubmit}
        >
          <h1 style={{ fontSize: '22px', fontWeight: 800 }}>
            Verify Your Account
          </h1>
          <TextField className={classes.field} label='Verification Code' {...bindCode} />
          {info.message.length > 0 && <Alert severity={info.error ? 'error' : 'success'}>{info.message}</Alert>}
          <Button
            variant='contained'
            color='primary'
            size='large'
            type='submit'
            disabled={loading}
          >
            {loading && <CircularProgress size={20} style={{ marginRight: 20 }} />}
            Verify your account
          </Button>
        </form>
      </div>
    )
  )
}
export default Confirmation
